export const shipmentsExcelMapping = {
  // Spanish column name -> internal field name
  Referencia: 'reference_number',
  Contenedor: 'container_number',
  Cliente: 'receiver',
  Nave: 'ship_name',
  'Fecha Despacho Packing': 'packing_etd',
  'Fecha ETD': 'ship_etd',
  'Código Embalaje': 'box_type',
  'Cantidad de Cajas': 'quantity',
  'Peso Caja': 'box_weight',
  'Variedad Real': 'variety',
  'Variedad Etiquetada': 'labeled_variety',
  Calibre: 'caliber',
  Color: 'color',
  Etiqueta: 'box_label',
  Categoría: 'category',
  'Nombre Productor': 'producer_name',

  'Tipo Nave': 'ship_type',
  'Fecha ETA': 'ship_eta',
  'Descripción Embalaje': 'box_description',
  'RUT Productor': 'producer_national_id',
  'Grupo Productor': 'producer_group',
  'Código SAG': 'producer_sag_code',
  Pallet: 'pallet',
  Lote: 'lot',
  'Fecha Recepción': 'reception_date',
  'Nro Proceso': 'process_internal_id',
  'Fecha Proceso': 'process_date',
  'Tipo de Negocio': 'business_type',
  'Orden de Venta': 'sale_order',
  Incoterm: 'original_incoterm',
  'Precio FOB': 'fob_price',
  'Factura SII': 'invoice_number',
  'Región de Venta': 'sale_region',
  'Mercado de Venta': 'sale_market',
  'Segregación Fruta': 'fruit_segregation',
  'Tipo Flete': 'freight_type',
  'Tipo de Frío': 'cold_type',
  Booking: 'booking_number',
  AWB: 'awb_number',
  'Booking / AWB': 'booking_number',
  // 'Planta de Proceso': 'packing_name',
};

export type FieldDefinition = {
  field: string;
  label: string;
  helperText?: string;
  required: boolean;
  shipmentField?: boolean;
};

export const requiredFields: FieldDefinition[] = [
  {
    field: 'reference_number',
    label: 'Referencia única del despacho',
    helperText:
      'Identifica un único contenedor o AWB. Usa Orden de Venta para agrupar despachos relacionados.',
    required: true,
    shipmentField: true,
  },
  {
    field: 'receiver',
    label: 'Cliente',
    helperText: 'Nombre del cliente/recibidor',
    required: true,
    shipmentField: true,
  },
  {
    field: 'ship_name',
    label: 'Nombre Nave',
    // helperText: 'Nombre de la nave de transporte',
    required: true,
    shipmentField: true,
  },
  {
    field: 'packing_etd',
    label: 'Fecha Despacho Packing',
    helperText: 'Fecha de despacho de packing',
    required: true,
    shipmentField: true,
  },
  {
    field: 'box_type',
    label: 'Código de Embalaje',
    helperText: 'Tipo de caja o embalaje',
    required: true,
  },
  {
    field: 'quantity',
    label: 'Cantidad de Cajas',
    // helperText: 'Número de cajas en el envío',
    required: true,
  },
  {
    field: 'box_weight',
    label: 'Peso Neto Caja',
    helperText: 'Peso neto de cada caja en kg (Ej: 2.5, 5, 10)',
    required: true,
  },
  {
    field: 'variety',
    label: 'Variedad Real',
    helperText: 'Variedad real del producto',
    required: true,
  },
  {
    field: 'labeled_variety',
    label: 'Variedad Etiquetada',
    helperText: 'Variedad indicada en la etiqueta',
    required: true,
  },
  {
    field: 'caliber',
    label: 'Calibre',
    helperText: 'Tamaño o calibre del producto (Ej: XL, L, J, 2J)',
    required: true,
  },
  {
    field: 'box_label',
    label: 'Etiqueta',
    helperText: 'Marca o etiqueta de la caja',
    required: true,
  },
  {
    field: 'category',
    label: 'Categoría',
    helperText: 'Categoría de calidad del producto (Ej: CAT1)',
    required: true,
  },
  {
    field: 'producer_name',
    label: 'Nombre Productor',
    helperText: 'Nombre del productor',
    required: true,
  },
];

export const shipmentIdentifierFields: FieldDefinition[] = [
  {
    field: 'container_number',
    label: 'Número de Contenedor',
    helperText: 'Obligatorio cuando el despacho no tiene AWB',
    required: false,
    shipmentField: true,
  },
  {
    field: 'awb_number',
    label: 'AWB',
    helperText: 'Obligatorio cuando el despacho no tiene contenedor',
    required: false,
    shipmentField: true,
  },
];

export const optionalFields: FieldDefinition[] = [
  {
    field: 'color',
    label: 'Color',
    helperText:
      'Color del producto (Ej: L, D, DD). Obligatorio solo para Cerezas.',
    required: false,
  },
  {
    field: 'ship_type',
    label: 'Tipo Nave',
    helperText: 'Tipo de transporte (aéreo, marítimo, terrestre)',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_etd',
    label: 'Fecha Despacho Nave (ETD)',
    helperText: 'Fecha de salida de la nave',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_eta',
    label: 'Fecha Arribo Nave (ETA)',
    helperText: 'Fecha estimada de llegada de la nave',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_origin_port',
    label: 'Puerto de Origen',
    // helperText: 'Puerto de origen del envío',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_destination_port',
    label: 'Puerto de Destino',
    // helperText: 'Puerto de destino del envío',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_origin_country',
    label: 'País de Origen',
    // helperText: 'País de origen del envío',
    required: false,
    shipmentField: true,
  },
  {
    field: 'ship_destination_country',
    label: 'País de Destino',
    // helperText: 'País de destino del envío',
    required: false,
    shipmentField: true,
  },
  {
    field: 'box_description',
    label: 'Descripción Embalaje',
    // helperText: 'Descripción adicional del embalaje',
    required: false,
  },
  {
    field: 'producer_national_id',
    label: 'RUT Productor',
    helperText: 'RUT del productor',
    required: false,
  },
  {
    field: 'producer_group',
    label: 'Grupo Productor',
    helperText: 'Grupo o cooperativa del productor',
    required: false,
  },
  {
    field: 'producer_sag_code',
    label: 'Código SAG Productor',
    helperText: 'Código SAG del productor',
    required: false,
  },
  {
    field: 'pallet',
    label: 'Pallet',
    helperText: 'Número de pallet',
    required: false,
  },
  {
    field: 'lot',
    label: 'Lote',
    helperText: 'Número de lote',
    required: false,
  },
  {
    field: 'reception_date',
    label: 'Fecha Recepción',
    helperText:
      'Fecha de recepción en planta, útil si liquidas por fecha de recepción',
    required: false,
  },
  {
    field: 'process_internal_id',
    label: 'Nro Proceso',
    helperText: 'Número interno de proceso',
    required: false,
  },
  {
    field: 'process_date',
    label: 'Fecha Proceso',
    helperText:
      'Fecha de proceso en planta, útil si liquidas por fecha de proceso',
    required: false,
  },
  {
    field: 'business_type',
    label: 'Tipo de Negocio',
    helperText:
      'Por ejemplo: Mínimo Garantizado, Libre Consignación, En Firme, etc.',
    required: false,
    shipmentField: true,
  },
  {
    field: 'sale_order',
    label: 'Orden de Venta',
    helperText: 'Útil si agrupas varios embarques en una sola orden de venta.',
    required: false,
    shipmentField: true,
  },
  {
    field: 'original_incoterm',
    label: 'Incoterm',
    helperText: 'Por ejemplo: FOB, CIF, etc.',
    required: false,
    shipmentField: true,
  },
  {
    field: 'fob_price',
    label: 'Precio FOB',
    helperText:
      'Si es que tienes un precio preacordado, en firme, mínimos garantizados, etc.',
    required: false,
  },
  {
    field: 'invoice_number',
    label: 'Factura SII',
    helperText: 'Número de factura SII',
    required: false,
    shipmentField: true,
  },
  {
    field: 'sale_region',
    label: 'Región de Venta',
    helperText: 'Región de venta (Lejano Oriente, USA, Europa, etc.)',
    required: false,
    shipmentField: true,
  },
  {
    field: 'sale_market',
    label: 'Mercado de Venta',
    helperText: 'Mercado de venta',
    required: false,
    shipmentField: true,
  },
  {
    field: 'fruit_segregation',
    label: 'Segregación Fruta',
    helperText: 'Segregación de fruta (Premium, Estándar, Regular, etc.)',
    required: false,
  },
  {
    field: 'freight_type',
    label: 'Tipo Flete',
    helperText: 'Tipo de flete (Prepaid / Collect)',
    required: false,
    shipmentField: true,
  },
  {
    field: 'cold_type',
    label: 'Tipo de Frío',
    helperText: 'Tipo de frío utilizado',
    required: false,
  },
  {
    field: 'booking_number',
    label: 'Booking',
    helperText: 'Número de Booking',
    required: false,
    shipmentField: true,
  },
];

export const multiPackingField: FieldDefinition = {
  field: 'packing_name',
  label: 'Planta de Proceso (Packing)',
  helperText: 'Nombre de la planta de empaque en cada fila',
  required: true,
};

export type ShipmentRow = {
  [K in keyof typeof shipmentsExcelMapping]: string | number;
};
